export const informationTextMessage = `W celu złożenia korekty sprawozdania, prosimy o kontakt telefoniczny: 12 630 31 00 lub mailowy: powietrze@umwm.malopolska.pl - w temacie wiadomości proszę wpisać "Korekta sprawozdania - Małopolski Ekoportal."

W celu korekty formularza dotyczącego Obszaru Edukacja, prosimy o kontakt tefeoniczny:
- dla szkół kształcących w zawodach medycznych, tel.: 12 61 60 705,
- dla szkół przyszpitalnych, specjalnych oraz młodzieżowych ośrodków wychowawczych, tel.:12 61 60 760
- dla bibliotek pedagogicznych oraz ZSMS, tel.: 12 61 60 708.`;
